const WORDS = ["Aéroport", "Mise à disposition", "Mariage", "Affaires", "Longue distance", "Événements"];

export default function Marquee() {
  const items = [...WORDS, ...WORDS];
  return (
    <section data-testid="marquee" className="bg-[#0B132B] border-y border-white/10 py-8 md:py-10 overflow-hidden">
      <div className="marquee-track">
        {items.map((w, i) => (
          <span key={i} className="inline-flex items-center">
            <span className="font-display italic text-4xl md:text-6xl text-white px-8">{w}</span>
            <span className="text-[#8ea2c8] text-3xl md:text-5xl">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
}
